import {EventType} from '../../enum/event-type';
import {EmitterEvent} from './prototype/emitter-event';
import {ObservableEmitter} from './prototype/observable-emitter';
import {Injectable} from '@angular/core';

@Injectable()
export class EmitService {

  private _listener: ObservableEmitter[];

  constructor() {
    this._listener = [];
  }

  public on(eventType: EventType, callback: any, classType): void {
    if (this.isRegistered(eventType, classType) !== -1) {
      return;
    }

    const tmp: ObservableEmitter = new ObservableEmitter(eventType, callback, classType);
    this._listener.push(tmp);
  }

  public remove(eventType: EventType, classType): void {
    const index: number = this.isRegistered(eventType, classType);
    if (index === -1) {
      return;
    }

    this._listener[index].unsubscribe();
    this._listener.splice(index, 1);
  }

  private isRegistered(eventType: EventType, classType): number {
    for (let i = 0; i < this._listener.length; i++) {
      if ((classType === this._listener[i].classType)
        && (eventType === this._listener[i].eventType)) {
        return i;
      }
    }

    return -1;
  }

  public dispatcher(event: EmitterEvent) {
    for (let i = 0; i < this._listener.length; i++) {
      if (event.eventType === this._listener[i].eventType) {
        this._listener[i].emit(event);
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/event/emit.service.ts